<div *ngIf='pricesLoading && hardReload' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<ng-container *ngIf="checkoutType == 'split'">
  <p class="mt-3 mb-1 font-16 fontSemiBold">{{'checkout.Your share of order amount' | translate}}</p>
</ng-container>

<div class="order-prices-details" *ngIf="(orderDetails && !pricesLoading) || !hardReload">
  <div class="d-flex">
    <span class="font-14 fontRegular">{{'content4.Subtotal' | translate }}</span>
    <span class="ml-auto font-14 fontMedium d-ltr">
      <span class="fontLight" *ngIf="currency">{{currency!.currencyCode}}</span>
      <span> {{orderDetails.subTotal}}</span>
    </span>
  </div>

  <div class="d-flex">
    <div class="font-14 fontRegular">
      <span>{{'content2.Service' | translate }}</span>
      <span class="font-12" *ngIf="orderDetails.servicePercentage"> ({{orderDetails.servicePercentage}}%)</span>
    </div>
    <div class="ml-auto font-14 fontMedium">
      <span class="d-ltr" *ngIf="orderDetails.serviceValue">
        <span class="fontLight" *ngIf="currency">{{currency!.currencyCode}}</span>
        <span> {{orderDetails.serviceValue}}</span>
      </span>
      <span *ngIf="!orderDetails.serviceValue">{{'placeOrder.Free' | translate}}</span>
    </div>
  </div>
  <!-- <div class="d-flex">
    <div class="font-14 fontRegular">
      <span>{{'content2.Tax' | translate }}</span>
      <span class="font-12" *ngIf="orderDetails.taxPercentage"> ({{orderDetails.taxPercentage}}%)</span>
    </div>
    <div class="ml-auto font-14 fontMedium">
      <span class="d-ltr" *ngIf="orderDetails.taxValue">
        <span class="fontLight">{{currency!.currencyCode}}</span>
        <span> {{orderDetails.taxValue}}</span>
      </span>
      <span *ngIf="!orderDetails.taxValue">{{'placeOrder.Free' | translate}}</span>
    </div>
  </div> -->
  <!-- Surcharge -->
  <div class="d-flex" *ngIf="orderDetails.surchargeValue">
    <div class="d-flex align-items-center">
      <span class="font-14 fontRegular">{{'placeOrder.Surcharge' | translate }}</span>
      <button matRipple class="btn danger"
        *ngIf="orderDetails.canManageSurcharge
          || orderDetails.reservationType == 'TakeAway'"
        (click)="removeSurcharge()"
        ><mat-icon>delete</mat-icon><span>{{'checkout.Remove' | translate}}</span>
      </button>
    </div>
    <span class="ml-auto font-14 fontLight red-color">
      +
      <span class="d-ltr" *ngIf="currency">
        {{currency!.currencyCode}}
        <span class="font-14 fontMedium">{{orderDetails.surchargeValue}}</span>
      </span>
    </span>
  </div>
  <!-- Deposit -->
  <div class="d-flex" *ngIf="orderDetails.deposit">
    <div class="d-flex align-items-center">
      <span class="font-14 fontRegular">{{'checkout.Reservation Deposit' | translate }}</span>
    </div>
    <span class="ml-auto font-14 fontLight light-green-color text-nowrap">
      -
      <span class="d-ltr" *ngIf="currency">
        {{currency!.currencyCode}}
        <span class="font-14 fontMedium">{{orderDetails.deposit}}</span>
      </span>
    </span>
  </div>
  <!-- Discounts -->
  <div class="d-flex" *ngIf="orderDetails.discountValue">
    <div class="d-flex align-items-center">
      <span class="font-14 fontRegular">{{'checkout.Discounts' | translate }}</span>
      <span class="font-12 fontRegular grey-color ml-1">
        ({{orderDetails.discountName ? orderDetails.discountName : ('placeOrder.Manual Discount'|translate)}})
      </span>
      <button matRipple class="btn danger"
        *ngIf="orderDetails.canManageDiscount
          || orderDetails.reservationType == 'TakeAway'"
        (click)="removeDiscount()">
        <mat-icon>delete</mat-icon><span>{{'checkout.Remove' | translate}}</span>
      </button>
    </div>
    <span class="ml-auto font-14 fontLight light-green-color text-nowrap">
      -
      <span class="d-ltr" *ngIf="currency">
        {{currency!.currencyCode}}
        <span class="font-14 fontMedium">{{orderDetails.discountValue}}</span>
      </span>
    </span>
  </div>

  <div class="d-flex" *ngFor="let tax of orderDetails.taxList">
    <div class="font-14 fontRegular">
      <span>{{tax.taxName}}</span>
      <span class="font-12"> ({{tax.taxValue}}%)</span>
      <!-- {{tax.taxValue + (tax.taxtype == 0 ? '%' : currency!.currencyCode)}} -->
    </div>
    <div class="ml-auto font-14 fontMedium" *ngIf="currency">
      <span class="d-ltr" *ngIf="tax.taxValue">
        <span class="fontLight">{{currency!.currencyCode}}</span>
        <span> {{tax.taxTotal}}</span>
      </span>
      <span *ngIf="!tax.taxValue">{{'placeOrder.Free' | translate}}</span>
    </div>
  </div>

  <!-- Total -->
  <hr class="m-0">
  <div class="total d-flex font-18"
    [class.orange-color]="!(orderDetails.paid && !orderDetails.isTotalyPaid)">
    <span class="fontMedium">{{'placeOrder.Total' | translate }}</span>
    <span class="ml-auto fontLight d-ltr" *ngIf="currency">
      {{currency!.currencyCode}}
      <span class="fontBold">{{orderDetails.total}}</span>
    </span>
  </div>

  <ng-container *ngIf="orderDetails.paid && !orderDetails.isTotalyPaid">
    <!-- Paid -->
    <hr class="m-0">
    <div class="d-flex">
      <span class="font-14 fontRegular">{{'orders.Paid' | translate }}</span>
      <span class="ml-auto font-14 fontLight d-ltr" *ngIf="currency">
        {{currency!.currencyCode}}
        <span class="font-14 fontMedium">{{orderDetails.paid}}</span>
      </span>
    </div>
    <!-- To be Paid -->
    <hr class="m-0">
    <div class="total d-flex font-18 orange-color">
      <span class="fontMedium">{{'checkout.To be Paid' | translate }}</span>
      <span class="ml-auto fontLight d-ltr" *ngIf="currency">
        {{currency!.currencyCode}}
        <span class="fontBold">{{orderDetails.toBePaid}}</span>
      </span>
    </div>
  </ng-container>
</div>
